import React, { useState } from 'react'
import styled from 'styled-components'
import { Button } from '@raysync/common/components'
import { Media } from '@raysync/common/theme'
import SearchIcon from '@raysync/common/components/svg/document/search'
const SearchContainer = styled.div`
  width: 800px;
  display: flex;
  justify-content: center;
  position: relative;
  box-shadow: 0px 2px 10px 0px rgba(99, 103, 114, 0.1);
  border-radius: 25px;
  height: 50px;
  button {
    width: 10%;
    height: 100%;
    border-radius: 0px 25px 25px 0px;
    svg {
      width: 25px;
    }
  }
  input {
    width: 90%;
    height: 100%;
    padding: 10px 10px 10px 26px;
    border: none;
    border-radius: 4px;
    background: #ffffff;
    border-radius: 25px 0px 0px 25px;
    outline: none;
  }
  ${Media.phone`
    width: 100%;
    height: .6rem;
    border-radius: .3rem;
    button {
      padding: 0;
      svg {
        width: .3rem;
        margin-top: -.1rem;
      }
    }
    input {
      padding: .1rem .1rem .1rem .3rem;
      border-radius: .3rem 0px 0px .3rem;
    }
  `}
`

export function SearchInput({ handleSearch, value }) {
  const [inputValue, setInputValue] = useState('')
  React.useEffect(() => {
    setInputValue(value)
  }, [value])
  return (
    <SearchContainer className='search-container'>
      <input
        type='text'
        value={inputValue}
        placeholder='请输入搜索关键词'
        onKeyDown={e => {
          if (e.key === 'Enter') {
            handleSearch(inputValue)
          }
        }}
        onChange={e => setInputValue(e.target.value)}
      />
      <Button
        onClick={() => {
          handleSearch(inputValue)
        }}
      >
        <SearchIcon />
      </Button>
    </SearchContainer>
  )
}
